import styled from 'styled-components';
import { useIsMsalAuth } from '@equifinance/shared';
import { SectionSidebarItem } from '../../Sidebar/SectionSidebarItem';
import { UserMamagement } from '../sections/UserManagementSection';
import { ApiManagement } from '../sections/ApiSection';
import { useCompanyTabNavHeight } from '../../Company/components/CompanyTabNav';
import { useCompanyContext } from '../../../contexts/company';
import { useBdmAssignedName } from '../../BrokerDetails/hooks/useBdmAssignedName';

export const SidebarInfo = styled.div` ${({ theme }) => `
  padding: ${theme.padding[4]} ${theme.padding[6]};
`}`;

export const Label = styled.span` ${({ theme }) => `
  color:${theme.colours.neutral[2]};
  font-size:${theme.fontSize[1]}; 
  font-weight:${theme.fontWeight.bold}; 
`}`;

export const ProgressBarHyperlink = styled.a`${({ theme }) => `
  padding: ${theme.padding[4]} ${theme.padding[6]};  
  display: flex;
  align-items: center;
  text-decoration: none;
`}`;

export const ProgressBarTextHyperlink = styled.a`${({ theme }) => `
  padding-left: ${theme.padding[2]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bold};
  text-decoration: underline;
  color: ${theme.colours.link[1]};
`}`;

const Icon = styled.i<{ color?: string }>`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[3]};
`}`;

const BDM_CONTACT_DETAILS = `${process.env.REACT_APP_BDM_CONTACT_DETAILS}/` || 'https://www.equifinance.co.uk/sales-team/';

export function BDMContactDetails() {
  return (
    <ProgressBarHyperlink
      href={BDM_CONTACT_DETAILS}
      target="_blank"
    >
      <Icon className="mi-users" />
      <ProgressBarTextHyperlink>
        BDM contact details
      </ProgressBarTextHyperlink>
    </ProgressBarHyperlink>
  );
}

export default function ManageUserSidebar() {
  const stickyHeaderOffset = useCompanyTabNavHeight();
  const { company } = useCompanyContext();
  const isInternalUser = useIsMsalAuth();
  const BdmName = useBdmAssignedName(company.bdmAssigned);

  return (
    <>
      {isInternalUser && (
        <SidebarInfo>
          <Label>BDM:</Label>
          {' '}
          {BdmName}
        </SidebarInfo>
      )}

      <BDMContactDetails />

      <SectionSidebarItem
        icon={<></>}
        stickyHeaderOffset={stickyHeaderOffset}
        refName={UserMamagement}
      >
        User Management
      </SectionSidebarItem>

      <SectionSidebarItem
        icon={<></>}
        stickyHeaderOffset={stickyHeaderOffset}
        refName={ApiManagement}
      >
        API
      </SectionSidebarItem>
    </>
  );
}
